export default "__VITE_ASSET__B9Vl1E17__"